import { useState, useEffect } from "react";
import axios from "axios";
import "./styles/ReportPage.css";
import search from "/assets/icon/Search.svg";
import ArrowDown from "/assets/ArrowDown.svg";
import UserStatus from "../../components/UserStatus";
import DownloadReportWindow from "../../components/DownloadReportWindow";

function ShowBranchDetailReport() {
  const [searchQuery, setSearchQuery] = useState("");
  const [branchData, setBranchData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchDetails, setBranchDetails] = useState({ users: [], poles: [] });
  const [showUsersTable, setShowUsersTable] = useState(false);
  const [showPolesTable, setShowPolesTable] = useState(false);
  const [showDownloadReport, setShowDownloadReport] = useState(false);

  const handleDownloadReportClick = () => {
    setShowDownloadReport(true);
  };

  const handleDownloadReportClose = () => {
    setShowDownloadReport(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSelection = () => {
    setSelectedBranch(null);
    setSearchQuery("");
    setBranchDetails({ users: [], poles: [] });
    setShowUsersTable(false);
    setShowPolesTable(false);
  };

  useEffect(() => {
    const fetchBranchData = async () => {
      if (searchQuery.trim() === "") {
        setBranchData([]); // Clear branch data if search query is empty
        return;
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/branchSearch?searchQuery=${searchQuery}`
        );
        console.log("Branch Data:", response.data); // Debug log
        setBranchData(response.data);
      } catch (error) {
        console.error("Error fetching branch data:", error);
      }
    };

    fetchBranchData();
  }, [searchQuery]);

  useEffect(() => {
    const fetchBranchDetails = async () => {
      if (!selectedBranch) return;
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/branchDetails/${selectedBranch.id}`
        );
        console.log("Branch Details:", response.data); // Debug log
        setBranchDetails(response.data);
      } catch (error) {
        console.error("Error fetching branch details:", error);
      }
    };

    fetchBranchDetails();
  }, [selectedBranch]);

  const handleBranchClick = (branch) => {
    if (selectedBranch && selectedBranch.id === branch.id) {
      setSelectedBranch(null); // Deselect if clicking the same branch
      setSearchQuery(""); // Clear search query on deselect
      setBranchDetails({ users: [], poles: [] });
      setShowUsersTable(false);
      setShowPolesTable(false);
    } else {
      setSelectedBranch(branch);
      setSearchQuery(branch.name); // Update search query with selected branch name
    }
  };

  const mainPoles = branchDetails.poles.filter((pole) => pole.is_master);
  const secondaryPoles = branchDetails.poles.filter((pole) => !pole.is_master);

  return (
    <div className="showWeatherReport">
      <h1>รายละเอียดของแต่ละสาขา</h1>

      <h4 className="downloadReport" onClick={handleDownloadReportClick}>
        ดาวน์โหลดรายงาน
      </h4>

      <p>ค้นหาชื่อสาขา, รหัสสาขา</p>
      <div className="searchbarreport">
        <div className="search-bar">
          <img src={search} alt="search" className="search-user" />
          <input
            type="text"
            placeholder="ค้นหาชื่อสาขา, รหัสสาขา"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          {selectedBranch && (
            <button className="clear-button" onClick={handleClearSelection}>
              &times;
            </button>
          )}
        </div>
      </div>
      <div className="searchResults">
        {searchQuery && (
          <>
            {selectedBranch ? (
              <div
                className="resultItem"
                onClick={() => handleBranchClick(selectedBranch)}
                style={{ cursor: "pointer", border: "2px solid #2762F8" }}
              >
                <p>
                  <strong>ชื่อสาขา:</strong> {selectedBranch.name}
                </p>
                <p>
                  <strong>Location:</strong> {selectedBranch.location}
                </p>
                <p>
                  <strong>Latitude:</strong> {selectedBranch.lat},{" "}
                  {selectedBranch.lng}
                </p>
              </div>
            ) : (
              branchData.map((branch) => (
                <div
                  key={branch.id}
                  className="resultItem"
                  onClick={() => handleBranchClick(branch)}
                  style={{ cursor: "pointer" }}
                >
                  <p>
                    <strong>ชื่อสาขา:</strong> {branch.name}
                  </p>
                  <p>
                    <strong>Location:</strong> {branch.location}
                  </p>
                  <p>
                    {branch.lat},{branch.lng}
                  </p>
                </div>
              ))
            )}
          </>
        )}
      </div>
      {branchDetails.users.length > 0 && (
        <>
          <h2
            className="toggleHeader"
            onClick={() => setShowUsersTable(!showUsersTable)}
            style={{ cursor: "pointer" }}
          >
            ผู้ใช้งานในสาขา {selectedBranch.name}{" "}
            <strong>({branchDetails.users.length})</strong>
            <img
              src={ArrowDown}
              alt="Toggle Arrow"
              className={`arrow ${showUsersTable ? "rotated" : ""}`}
            />
          </h2>
          {showUsersTable && (
            <div className="showReportSection">
              <table className="sensorDataTable">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>ชื่อผู้ใช้งาน</th>
                    <th>อีเมล</th>
                    <th>หมายเลขโทรศัพท์</th>
                    <th>สถานะ</th>
                  </tr>
                </thead>
                <tbody>
                  {branchDetails.users.map((user, index) => (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.phone_no}</td>
                      <td className="w100">
                        <div className="w150">
                          <UserStatus isOnline={user.active} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
      {branchDetails.poles.length > 0 && (
        <>
          <h2
            className="toggleHeader"
            onClick={() => setShowPolesTable(!showPolesTable)}
            style={{ cursor: "pointer" }}
          >
            เสาในสาขา {selectedBranch.name}{" "}
            <strong>({branchDetails.poles.length})</strong>
            <img
              src={ArrowDown}
              alt="Toggle Arrow"
              className={`arrow ${showPolesTable ? "rotated" : ""}`}
            />
          </h2>
          {showPolesTable && (
            <div className="showReportSection">
              <table className="sensorDataTable">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>ชื่อเสา</th>
                    <th>ประเภท</th>
                    <th>Location</th>
                    <th>Latitude</th>
                    <th>Longitude</th>
                    <th>สถานะ</th>
                  </tr>
                </thead>
                <tbody>
                  {mainPoles.concat(secondaryPoles).map((pole, index) => (
                    <tr key={pole.id}>
                      <td>{index + 1}</td>
                      <td>{pole.name}</td>
                      <td>{pole.is_master ? "เสาหลัก" : "เสารอง"}</td>
                      <td>{pole.location}</td>
                      <td>{pole.lat}</td>
                      <td>{pole.lng}</td>
                      <td>
                        <UserStatus isOnline={pole.active} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
      {showDownloadReport && (
        <DownloadReportWindow
          onClose={handleDownloadReportClose}
          jsonData={{
            branchInfo: selectedBranch
              ? {
                  name: selectedBranch.name,
                  location: selectedBranch.location,
                  latitude: selectedBranch.lat,
                  longitude: selectedBranch.lng,
                  id: selectedBranch.id,
                }
              : null,
            branchDetails,
          }}
          fileName={
            selectedBranch
              ? `${selectedBranch.name}_branch_detail_report`
              : "branch_detail_report"
          }
          routeName="showbranchdetail"
        />
      )}
    </div>
  );
}

export default ShowBranchDetailReport;
